export default __webpack_public_path__ + "static/bg-1-overlay-desktop-9071e141314692c2560a97048522bfc3.png";